// localStorage for the admin session. The session token itself is an httpOnly
// cookie that scripts cannot read; here we keep only what the UI needs: who is
// logged in and when the session ends (so it can log out on time and other
// tabs can follow). Neither value grants access on its own.

export const USER_KEY = 'user';
export const SESSION_EXPIRES_KEY = 'sessionExpiresAt';
const LEGACY_TOKEN_KEY = 'authToken'; // JWTs used to be stored here

function safe(fn, fallback = null) {
  try {
    return fn();
  } catch {
    return fallback;
  }
}

// Drop tokens saved by older versions of the app.
safe(() => localStorage.removeItem(LEGACY_TOKEN_KEY));

export function readUser() {
  return safe(() => {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  });
}

export function readSessionExpiry() {
  const value = Number(safe(() => localStorage.getItem(SESSION_EXPIRES_KEY)));
  return Number.isFinite(value) && value > 0 ? value : null;
}

export function writeSession(user, expiresAt) {
  safe(() => {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
    localStorage.setItem(SESSION_EXPIRES_KEY, String(expiresAt));
  });
}

export function removeSession() {
  safe(() => {
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(SESSION_EXPIRES_KEY);
    localStorage.removeItem(LEGACY_TOKEN_KEY);
  });
}
